const stack = {
    eyebrow: 'Stack',
    title: 'What I work with',
    description: 'The tools I reach for day to day, grouped by where they sit in the system.',
};

export default stack;
